import { CheckCircle, RefreshCw } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface NotificationActionsDesktopProps {
  transformedNotifications: any[];
  loading: boolean;
  error: any;
  onMarkAsRead: (ids: string[], markAll?: boolean) => void;
  onRefetch: () => void;
  className?: string;
}

export function NotificationActionsDesktop({
  transformedNotifications,
  loading,
  error: _error,
  onMarkAsRead,
  onRefetch,
  className,
}: NotificationActionsDesktopProps) {
  const unreadCount = transformedNotifications.filter((n) => !n.isRead).length;

  return (
    <TooltipProvider>
      <div className={cn("flex items-center gap-3", className)}>
        {/* Refresh button */}
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="sm"
              onClick={onRefetch}
              disabled={loading}
              className="h-9"
            >
              <RefreshCw className={cn("h-4 w-4 mr-2", loading && "animate-spin")} />
              Refresh
            </Button>
          </TooltipTrigger>
          <TooltipContent>Refresh notifications (Ctrl+R)</TooltipContent>
        </Tooltip>

        {/* Mark all as read when items exist */}
        {transformedNotifications.length > 0 && unreadCount > 0 && (
          <>
            <Separator orientation="vertical" className="h-6" />

            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onMarkAsRead([], true)}
                  className="h-9"
                >
                  <CheckCircle className="h-4 w-4 mr-2" />
                  Mark all as read
                  {unreadCount > 0 && (
                    <Badge variant="secondary" className="ml-2 h-5 text-xs">
                      {unreadCount}
                    </Badge>
                  )}
                </Button>
              </TooltipTrigger>
              <TooltipContent>Mark all {unreadCount} unread notifications as read</TooltipContent>
            </Tooltip>
          </>
        )}
      </div>
    </TooltipProvider>
  );
}
